import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType } from '../Actions/ActionTypes';
import { me } from '../../../config/api';
import { ActionType as RouterActionType } from '../SubComponent/Main/Router/Actions/ActionTypes';


function fetchMe() {
    return axios.get(me)
}


export const actionFetchUser = () => {
    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.USER_LOADING })
        fetchMe().then((res) => {
            dispatch({ type: ActionType.USER_LOADED, user: res.data.data })
            
            dispatch({ type: RouterActionType.UPDATE_MAIN_UI })

        }).catch(err => {

            dispatch({ type: ActionType.USER_LOADED, user: undefined })

        })

    }
}